export default __webpack_public_path__ + "static/media/register.94269a52.svg";